import React from 'react';

import { CommonHash, PersonalStatementQuestion } from 'app/types';

import styles from '../PersonalStatementBuilder.module.scss';
import { LabelInputComponent } from '../PersonalStatementBuilder';
import Text from 'common/components/Text/Text';
import TextQuestion from './TextQuestion';

interface CompProps {
  setInputOption: (
    key: string,
    value: any,
    setStateFunction: (value: React.SetStateAction<CommonHash>) => void
  ) => void;
  futureSkillsQuestion?: PersonalStatementQuestion;
  futureSkills: CommonHash;
  setFutureSkills: React.Dispatch<React.SetStateAction<CommonHash>>;
  setFutureSkillsOptions: React.Dispatch<React.SetStateAction<string[]>>;
  showFutureSkillsOptions: boolean;
  futureSkillsOptions: string[];
  handleAddBulletOption: (
    option: string,
    setStateOptionsFunction: (value: React.SetStateAction<string[]>) => void,
    setStateFunction: (value: React.SetStateAction<CommonHash>) => void,
    stateToChange: CommonHash
  ) => void;
  skillsDevelopmentQuestion?: PersonalStatementQuestion;
  careerAspirationsQuestion?: PersonalStatementQuestion;
  answers: CommonHash;
  setAnswer: (h: CommonHash) => void;
  deleteBulletInputOption: (
    key: string,
    setStateFunction: (value: React.SetStateAction<CommonHash>) => void,
    stateToChange: CommonHash
  ) => void;
  dependencyTags: string[];
  setAvailableTags: React.Dispatch<React.SetStateAction<string[]>>;
}

export const FutureSkillsStep = ({
  setInputOption,
  futureSkills,
  futureSkillsQuestion,
  setFutureSkills,
  setFutureSkillsOptions,
  showFutureSkillsOptions,
  futureSkillsOptions,
  handleAddBulletOption,
  skillsDevelopmentQuestion,
  careerAspirationsQuestion,
  answers,
  setAnswer,
  deleteBulletInputOption,
  dependencyTags,
  setAvailableTags,
}: CompProps): React.ReactElement => {
  return (
    <>
      <div className={styles.stepTitle} style={{ marginBottom: '8px' }}>
        Future goals
      </div>
      <div className={styles.stepSubtitle}>
        This section highlights how your desired programme will help you achieve your goals.
      </div>
      {futureSkillsQuestion && (
        <>
          <div className={styles.statementQuestion} style={{ marginTop: '40px' }}>
            {futureSkillsQuestion?.title}&nbsp;
            {futureSkillsQuestion?.min_content &&
              `(at least ${futureSkillsQuestion.min_content} answers)`}
          </div>
          {Object.keys(futureSkills.content).map((key) => (
            <LabelInputComponent
              key={key}
              keyNumber={key}
              setInputFunction={setInputOption}
              setObjectFunction={setFutureSkills}
              inputValue={futureSkills.content[key]}
              placeholderText="Choose or type in your answers"
              canBeDeleted={Object.keys(futureSkills.content).length > 3}
              deleteBulletInputOption={deleteBulletInputOption}
              stateToChange={futureSkills}
              dependencyTags={dependencyTags}
              setAvailableTags={setAvailableTags}
            />
          ))}
          <div
            className={styles.itemLabel}
            style={{ marginTop: '20px' }}
            onClick={() =>
              setInputOption(
                (Object.keys(futureSkills['content']).length + 1).toString(),
                '',
                setFutureSkills
              )
            }
          >
            +
          </div>
          {!!showFutureSkillsOptions && (
            <div className={styles.optionsContainer}>
              {futureSkillsOptions.map((answerOption, index) => (
                <div
                  className={styles.bulletOption}
                  key={index}
                  onClick={() =>
                    handleAddBulletOption(
                      answerOption,
                      setFutureSkillsOptions,
                      setFutureSkills,
                      futureSkills
                    )
                  }
                >
                  <Text size={14} weight={600} inlineStyle={{ color: '#297DF2' }}>
                    {answerOption}
                  </Text>
                  <i className="bi bi-plus-circle" />
                </div>
              ))}
            </div>
          )}
        </>
      )}
      {skillsDevelopmentQuestion && (
        <TextQuestion
          question={skillsDevelopmentQuestion}
          answers={answers}
          setAnswer={setAnswer}
        />
      )}
      {careerAspirationsQuestion && (
        <TextQuestion
          question={careerAspirationsQuestion}
          answers={answers}
          setAnswer={setAnswer}
        />
      )}
    </>
  );
};
